import React from 'react';

export const UploadFileContentImportHelper = React.forwardRef((props, ref) => {
  let fileReader;

  const handleFileRead = (e) => {
    const content = fileReader.result;
    // do something with the content
    props.onFileReadComplete(content);
  }

  const handleFileChosen = (file) => {
    fileReader = new FileReader();
    fileReader.onloadend = handleFileRead;
    fileReader.readAsText(file);
  };  

  return (
    <input       
      id='file'      
      type="file" 
      ref={ref}
      style={{ display: 'none' }} 
      onChange={(e) => {
        handleFileChosen(e.target.files[0])
      }}
  />);
});
